import { ErrorCodes } from './enums/error-codes.enum';

export class CustomHttpError {
  errorCode: ErrorCodes;
  message?: string;

  constructor(errorCode: ErrorCodes, message?: string) {
    this.errorCode = errorCode;
    this.message = message;
  }
}
